export interface ElementColumnInfo {
  title: string;
  element: VacuumElementType;
  minimum: number;
  maximum: number;
  step: number;
}

export interface ColumnInfo {
  title: string;
  minimum: number;
  maximum: number;
  step: number;
}

export enum VacuumElementType {
  Carbon = "carbon",
  Cobalt = "cobalt",
  Chromium = "chromium",
  Tungsten = "tungsten",
  Niobium = "niobium",
  Tantalum = "tantalum",
  Titanium = "titanium",
  Aluminum = "aluminum",
  Boron = "boron",
  Zirconium = "zirconium",
  Hafnium = "hafnium",
  Iron = "iron",
  Rhenium = "rhenium"
}

export const carbonInfo: ElementColumnInfo = {
  element: VacuumElementType.Carbon,
  title: "Carbon",
  minimum: 0.0,
  maximum: 1, //0.85,
  step: 0.1
};

export const cobaltInfo: ElementColumnInfo = {
  element: VacuumElementType.Cobalt,
  title: "Cobalt",
  minimum: 0.0,
  maximum: 20.0,
  step: 2.0
};

export const chromiumInfo: ElementColumnInfo = {
  element: VacuumElementType.Chromium,
  title: "Chromium",
  minimum: 1, //1.5,
  maximum: 29.0,
  step: 1
};

export const tungstenInfo: ElementColumnInfo = {
  element: VacuumElementType.Tungsten,
  title: "Tungsten",
  minimum: 0.0,
  maximum: 15.0,
  step: 1
};

export const niobiumInfo: ElementColumnInfo = {
  element: VacuumElementType.Niobium,
  title: "Niobium",
  minimum: 0.0,
  maximum: 5.0,
  step: 0.5
};

export const tantalumInfo: ElementColumnInfo = {
  element: VacuumElementType.Tantalum,
  title: "Tantalum",
  minimum: 0.0,
  maximum: 12.0,
  step: 1
};

export const titaniumInfo: ElementColumnInfo = {
  element: VacuumElementType.Titanium,
  title: "Titanium",
  minimum: 0.0,
  maximum: 5.0,
  step: 0.5
};

export const aluminumInfo: ElementColumnInfo = {
  element: VacuumElementType.Aluminum,
  title: "Aluminum",
  minimum: 0.0,
  maximum: 7, //6.2,
  step: 0.5
};

export const boronInfo: ElementColumnInfo = {
  element: VacuumElementType.Boron,
  title: "Boron",
  minimum: 0.0,
  maximum: 0.06,
  step: 0.01
};

export const zirconiumInfo: ElementColumnInfo = {
  element: VacuumElementType.Zirconium,
  title: "Zirconium",
  minimum: 0.0,
  maximum: 0.5,
  step: 0.1
};

export const hafniumInfo: ElementColumnInfo = {
  element: VacuumElementType.Hafnium,
  title: "Hafnium",
  minimum: 0.0,
  maximum: 1.5,
  step: 0.25
};

export const ironInfo: ElementColumnInfo = {
  element: VacuumElementType.Iron,
  title: "Iron",
  minimum: 0.0,
  maximum: 20, //18.5,
  step: 2
};

export const rheniumInfo: ElementColumnInfo = {
  element: VacuumElementType.Rhenium,
  title: "Rhenium",
  minimum: 0.0,
  maximum: 7.0,
  step: 0.5
};

export const densityMetricInfo: ColumnInfo = {
  title: "Density (Metric)",
  minimum: 7.5,
  maximum: 9.5, //9.21,
  step: 0.5
};

export const densityImperialInfo: ColumnInfo = {
  title: "Density (Imperial)",
  minimum: 0.2, //0.28,
  maximum: 1, //0.96,
  step: 0.1
};

export const solidusFInfo: ColumnInfo = {
  title: "Solidus (\u00B0F)",
  minimum: 2200.0,
  maximum: 2480.0,
  step: 20
};

export const liquidousFInfo: ColumnInfo = {
  title: "Liquidous (\u00B0F)",
  minimum: 2350.0,
  maximum: 2575.0,
  step: 25
};

export const solidusCInfo: ColumnInfo = {
  title: "Solidus (\u00B0C)",
  minimum: 1200, //1204.0,
  maximum: 1360.0,
  step: 20
};

export const liquidousCInfo: ColumnInfo = {
  title: "Liquidous (\u00B0C)",
  minimum: 1280, //1288.0,
  maximum: 1420, //1410.0,
  step: 20
};

export const vacuumElementalColumns: ElementColumnInfo[] = [
  carbonInfo,
  chromiumInfo,
  tungstenInfo,
  niobiumInfo,
  tantalumInfo,
  titaniumInfo,
  aluminumInfo,
  boronInfo,
  zirconiumInfo,
  hafniumInfo,
  ironInfo,
  rheniumInfo
];
